import { ProductTag } from '../constants/products';

export function isForcedSoldOut(product, isVip, isFemale) {
  return (
    (product.tagIdList.includes(ProductTag.fakeSoldOut) && isVip) ||
    (product.tagIdList.includes(ProductTag.fakeSoldOutMens) &&
      isFemale &&
      isVip)
  );
}
